import { REHYDRATE } from 'redux-persist/lib/constants';
import { handleActions } from 'modules/helpers';

import { ActionTypes } from 'constants/index';

export const appState = {
  list: [],
  pages: 0,
  currentPage: 0,
  loading: false,
};

export default {
  supports: handleActions(
    {
      [REHYDRATE]: draft => {
        draft.list = [];
      },
      [ActionTypes.GET_SUPPORTS]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_SUPPORTS_SUCCESS]: (draft, { payload: { rows, pages, currentPage } }) => {
        draft.list = rows;
        draft.pages = pages;
        draft.currentPage = currentPage;
        draft.loading = false;
      },
      [ActionTypes.GET_SUPPORTS_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.CHECK_AS_READ]: () => {
        // Don't set loading: only marked as read, table stays visible
      },
      [ActionTypes.CHECK_AS_READ_SUCCESS]: (draft, { payload }) => {
        if (payload && payload.id != null && draft.list) {
          const idx = draft.list.findIndex(item => item.id === payload.id);
          if (idx !== -1) draft.list[idx] = { ...draft.list[idx], ...payload };
        }
      },
      [ActionTypes.CHECK_AS_READ_FAILURE]: () => {},
      [ActionTypes.DELETE_SUPPORT]: () => {
        // Don't set loading: deletion happens in the background
      },
      [ActionTypes.DELETE_SUPPORT_SUCCESS]: (draft, { payload: { id } }) => {
        draft.list = draft.list.filter(item => item.id !== id);
      },
      [ActionTypes.DELETE_SUPPORT_FAILURE]: () => {},
    },
    appState,
  ),
};
